import React, { useState, useEffect } from "react";
import { Dialog } from "../../../../../../ui/components/Dialog";
import { Button } from "../../../../../../ui/components/Button";
import { TextField } from "../../../../../../ui/components/TextField";
import { FeatherX } from "@subframe/core";

interface CreatePivotViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  suggestedName: string;
}

export const CreatePivotViewModal: React.FC<CreatePivotViewModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  suggestedName,
}) => {
  const [viewName, setViewName] = useState<string>(suggestedName);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (isOpen) {
      setViewName(suggestedName);
      setError("");
    }
  }, [isOpen, suggestedName]);

  const handleConfirm = () => {
    if (!viewName.trim()) {
      setError("View name is required");
      return;
    }

    onConfirm(viewName.trim());
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <Dialog.Content className="min-w-[400px] max-w-[500px]">
        {/* Header */}
        <div className="flex w-full items-center justify-between gap-4 p-6 border-b border-solid border-neutral-border">
          <div className="flex flex-col items-start gap-1">
            <h3 className="text-heading-3 font-heading-3 text-default-font">
              Create New Pivot View
            </h3>
            <p className="text-body font-body text-subtext-color">
              Give your pivot view a name
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-neutral-100 text-subtext-color hover:text-default-font transition-colors"
          >
            <FeatherX className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-4 p-6">
          <TextField
            label="View Name"
            error={error ? true : false}
            helpText={error || "This name will appear on the tab"}
          >
            <TextField.Input
              placeholder="Enter view name"
              value={viewName}
              onChange={(e) => {
                setViewName(e.target.value);
                setError("");
              }}
            />
          </TextField>
        </div>

        {/* Action Buttons */}
        <div className="flex w-full items-center justify-end gap-2 p-6 border-t border-solid border-neutral-border">
          <Button variant="neutral-tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="brand-primary"
            onClick={handleConfirm}
            disabled={!viewName.trim()}
          >
            Create View
          </Button>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

